import { defineStore } from 'pinia'
import { computed } from 'vue'
import { showToast } from 'vant'
import { t } from '@/i18n'
import { apiAddHistory, apiHistoryList } from '@/apis/theater'
import type { IResHistoryListItem, IReqAddHistory } from '@/types/apis/theater'
import { useUserStore } from './user'
import { usePaginatedStore } from '@/composables/useInteractionStore'

export const useHistoryStore = defineStore('history', () => {
  const userStore = useUserStore()

  // Layer 2: 分页数据管理（扁平存储，无 episode 追踪）
  const paginated = usePaginatedStore<IResHistoryListItem>({
    storageKey: 'history-records',
    fetchApi: apiHistoryList,
    getItemId: item => item.ScriptId,
  })

  // 覆盖 list：按观看时间倒序排列
  const list = computed(() =>
    [...paginated.dataMap.value.values()].sort((a, b) => {
      const timeA = new Date(a.LastWatchTime || a.CreateTime || 0).getTime()
      const timeB = new Date(b.LastWatchTime || b.CreateTime || 0).getTime()
      return timeB - timeA
    }),
  )

  // 记录播放历史（简化：移除冗余 if/else，统一先 API 后合并）
  const recordHistory = async (payload: IReqAddHistory) => {
    if (!userStore.isLogin) return
    try {
      const res = await apiAddHistory(payload)
      const existing = paginated.dataMap.value.get(payload.ScriptId)
      paginated.dataMap.value.set(
        payload.ScriptId,
        existing ? { ...existing, ...res.Body } : res.Body,
      )
    } catch (error) {
      console.error('记录播放历史失败:', error)
    }
  }

  // 清除历史记录（带 toast 提示）
  const clearHistory = () => {
    paginated.dataMap.value.clear()
    showToast(t('common.messages.historyCleared'))
  }

  return {
    ...paginated,
    list,
    recordHistory,
    clearHistory,
  }
})
